import React from 'react';

// Self-contained SVG brand marks so importer labels never depend on a logo CDN.
// Trademarks remain the property of their respective owners.
export default function CloudProviderLogo({provider,size=27}){
 if(provider==='google')return <svg aria-hidden="true" width={size} height={size} viewBox="0 0 87.3 78">
  <path fill="#0066DA" d="m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3L27.5 53H0c0 1.55.4 3.1 1.2 4.5z"/>
  <path fill="#00AC47" d="M43.65 25 29.9 1.2c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44A9.06 9.06 0 0 0 0 53h27.5z"/>
  <path fill="#EA4335" d="M73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75L86.1 57.5c.8-1.4 1.2-2.95 1.2-4.5H59.798l5.852 11.5z"/>
  <path fill="#00832D" d="M43.65 25 57.4 1.2C56.05.4 54.5 0 52.9 0H34.4c-1.6 0-3.15.45-4.5 1.2z"/>
  <path fill="#2684FC" d="M59.8 53H27.5L13.75 76.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z"/>
  <path fill="#FFBA00" d="m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3L43.65 25 59.8 53h27.45c0-1.55-.4-3.1-1.2-4.5z"/>
 </svg>;
 if(provider==='dropbox')return <svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill="#0061FF">
  <path d="M6 1.807 0 5.629l6 3.822 6.001-3.822L6 1.807Zm12 0-6 3.822 6 3.822 6-3.822-6-3.822ZM0 13.274l6 3.822 6.001-3.822L6 9.452 0 13.274Zm18-3.822-6 3.822 6 3.822 6-3.822-6-3.822ZM6 18.371l6.001 3.822 6-3.822-6-3.822L6 18.371Z"/>
 </svg>;
 // Frame.io's mark is play-button inspired, represented locally as a compact SVG.
 return <svg aria-hidden="true" width={size} height={size} viewBox="0 0 32 32">
  <defs><linearGradient id="takefold-frame-gradient" x1="0" y1="1" x2="1" y2="0">
   <stop offset="0" stopColor="#654BFE"/><stop offset="1" stopColor="#B156ED"/>
  </linearGradient></defs>
  <rect width="32" height="32" rx="9" fill="url(#takefold-frame-gradient)"/>
  <path d="M11 7.5a2 2 0 0 0-3 1.73v13.54a2 2 0 0 0 3 1.73l12-6.77a2 2 0 0 0 0-3.46Z" fill="#fff"/>
 </svg>;
}
